export const canviEscala = (value, max, min) => {
	if ((!value && value !== 0) || isNaN(max) || isNaN(min)) {
		return 0
	}
	const newValue = (value - min) / (max - min)
	//Si el valor està entre 0 i 1 no es te en compte el mínim perquè als minims els hi restem -1
	if (value > max) {
		return 1
	} else {
		return value === 0 ? 0 : value > 0 && value <= 1 ? value / max : newValue
	}
}
export const getMinMaxForKey = (dades, key) => {
	const values = dades
		.map((fila) => Number.parseFloat(String(fila?.[key] ?? '').replace(',', '.')))
		.filter(Number.isFinite)

	if (values.length === 0) return { min: null, max: null }
	return {
		min: Math.min(...values),
		max: Math.max(...values),
	}
}

// MAPBOX
export const MAPBOX_TOKEN = 'pk.eyJ1IjoiZGlhcmlhcmEiLCJhIjoiY2w2ZXU5bXV4MGlkczNkcW92b28yaDZhdiJ9.tvNkBuIYVXtyNMfZ0vJpwg'
export const mapStyle = 'mapbox://styles/diariara/clhsuubb4023301pg5r4nf18c'

export const BASE_INITIAL_VIEW = {
	longitude: 1.75,
	latitude: 41.4,
	zoom: 7,
}

export const getInitialViewByWidth = (width) => {
	if (width < 598 && width >= 500) {
		return {
			...BASE_INITIAL_VIEW,
			zoom: 6.7,
		}
	}
	if (width < 500 && width >= 450) {
		return {
			...BASE_INITIAL_VIEW,
			latitude: BASE_INITIAL_VIEW.latitude - 0.4,
			zoom: 6.6,
		}
	}
	if (width < 450 && width >= 400) {
		return {
			...BASE_INITIAL_VIEW,
			latitude: BASE_INITIAL_VIEW.latitude - 0.4,
			zoom: 6.5,
		}
	}
	if (width < 400) {
		return {
			...BASE_INITIAL_VIEW,
			latitude: BASE_INITIAL_VIEW.latitude - 0.4,
			zoom: 6.3,
		}
	}

	return BASE_INITIAL_VIEW
}
